// Exact UI action labels, expanded from shared nouns during localization.
export const actionEnglish: Record<string,string> = {
  '加载更多说话人': 'Load more speakers',
  '该分类暂无说话人': 'No speakers in this category',
  '没有匹配的说话人': 'No matching speakers',
  '目录有更新，刷新后查看最新人物。': 'The directory has updates. Refresh to see the latest people.',
  '搜索内容过长，请缩短至 256 字节以内。': 'Search text is too long. Keep it within 256 bytes.',
  '搜索名称或编号': 'Search by name or number',
  '查看状态暂未同步，联网后自动重试。': 'View status has not synced. It will retry when online.',
  '正在加载人物详情…': 'Loading person details…',
  '部分录音仍在整理，人物可能继续更新。': 'Some recordings are still being processed. People may continue to update.',
  '正在更新，当前显示已整理的目录。': 'Updating. Showing the available directory.',
  '更新暂未完成，当前显示上次整理的目录。': 'The update has not completed. Showing the previous directory.',
  '正在整理说话人目录…': 'Preparing the speaker directory…',
  '说话人目录暂不可用，请稍后刷新。': 'The speaker directory is unavailable. Please refresh later.',
  '说话人目录暂不可用，请稍后再试。': 'The speaker directory is unavailable. Please try again later.',
  '声纹状态暂不可用': 'Voiceprint status unavailable',
  '暂时无法更新': 'Unable to update',
  '目录暂不可用': 'Directory unavailable',
  '发现未发布的草稿': 'Unpublished draft found',
  '草稿预览': 'Draft preview',
  '预览草稿': 'Preview draft',
  '关闭草稿预览': 'Close draft preview',
  '关闭草稿恢复弹窗': 'Close draft recovery dialog',
  '保存时间：': 'Saved at: ',
  '保存时间未知': 'Save time unavailable',
  '编辑原文': 'Edit original',
  '恢复草稿': 'Restore draft',
  '群聊提及': 'Group mention',
  '群内原消息的已读状态暂不可用': 'Read status of the original group message is unavailable',
  '对方已阅读群内原消息': 'They have read the original group message',
  '对方尚未阅读群内原消息': 'They have not read the original group message',
  '你已阅读群内原消息': 'You have read the original group message',
  '你尚未阅读群内原消息': 'You have not read the original group message',
  '绑定邮箱': 'Bind email',
  '请输入邮箱地址': 'Enter your email address',
  '请输入有效的邮箱地址': 'Enter a valid email address',
  '请输入4位邮箱验证码': 'Enter the 4-digit email code',
  '验证码已发送，请查收邮箱': 'Code sent. Check your inbox.',
  '邮箱已绑定，正在刷新账号信息；刷新失败时可重试。': 'Email bound. Refreshing account details; you can retry if this fails.',
  '刷新账号信息': 'Refresh account details',
  '邮箱绑定成功': 'Email bound successfully',
  '该邮箱已绑定其他账号': 'This email is already linked to another account',
  '当前账号已绑定邮箱，请刷新账号信息': 'This account already has an email. Refresh account details.',
  '邮箱或验证码错误': 'Incorrect email or verification code',
  '邮箱绑定响应异常，请重试': 'Unexpected email binding response. Please try again.',
  '注销账号': 'Delete account',
  '正在检查…': 'Checking…',
  '注销方式已变化，请重新确认': 'The deletion method has changed. Please confirm again.',
  '无需等待，将立即注销。注销完成后无法恢复登录。': 'Your account will be deleted immediately. You cannot sign back in after deletion.',
  '账号将在 15 天等待期结束后注销，期间继续登录可撤销注销。': 'Your account will be deleted after 15 days. Signing in during this period cancels the request.',
  '申请成功、剩余 5 天及剩余 1 天时，将向绑定手机号发送短信提醒。': 'We will send SMS reminders when you submit the request, with 5 days left, and with 1 day left.',
  '请输入“确认注销”': 'Type “确认注销” to confirm',
  '确认注销': 'Confirm deletion',
  '正在处理…': 'Processing…',

  '共同群聊': 'Shared groups',
  '调整共同群聊宽度': 'Resize shared groups',
  '同步尚未完成，请继续同步': 'Sync is incomplete. Continue syncing.',
  '暂时无法打开群聊，请重试': 'Could not open this group. Try again.',
  '第 {v0} 页': 'Page {v0}',
  '暂时无法读取共同群聊，请重试': 'Could not read shared groups. Try again.',
  '正在获取共同群聊…': 'Loading shared groups…',
  '暂无共同群聊': 'No shared groups',
  '共同群聊读取失败': 'Could not read shared groups',
  '正在同步…': 'Syncing…',

  '账号已切换，无法保存；请保留窗口或复制内容后再关闭': 'Account changed. Keep this window open or copy the content before closing.',
  '发送到：': 'Send to: ',
  '草稿已保存': 'Draft saved',
  '正在保存草稿…': 'Saving draft…',
  '草稿保存失败，请重试': 'Could not save draft. Please retry.',
  '未保存': 'Not saved',
  '保留这篇长文的修改？': 'Keep changes to this article?',
  '保存草稿后，可以下次继续编辑。': 'Save a draft to continue editing later.',
  '保存并关闭': 'Save and close',
  '是否暂存草稿': 'Save a draft?',
  '保存草稿': 'Save draft',
  '确认修改': 'Confirm changes',
  '关闭草稿确认弹窗': 'Close draft confirmation',
  '放弃修改': 'Discard changes',

  "关闭用量与额度详情": "Close usage and limits details",
  "所属会话：": "Conversation: ",
  "保存修改": "Save changes",
  "只读": "Read only",
  "关闭添加长文": "Close add an article",
  "关闭充值弹窗": "Close add credit",
  "关闭日历": "Close calendar",
  "关闭当天内容": "Close this day's content",
  "关闭通话详情": "Close call details",
  "返回联系人与通话入口": "Back to contacts & calls",
  "打开联系人与通话入口": "Open contacts & calls",
  "返回联系人选择": "Back to contact selection",
  "关闭通话邀请": "Close call invitation",
  "关闭联系人选择": "Close contact selection",
  "关闭通话引导": "Close call tour",
  "关闭录像": "Close video recording",
  "关闭成员快记": "Close member notes",
  "关闭聊天预览": "Close chat preview",
  "关闭二维码识别": "Close qR code scanner",
  "关闭聊天搜索": "Close chat search",
  "关闭我的一天": "Close my day",
  "关闭活动详情": "Close activity details",
  "关闭回复列表": "Close replies",
  "关闭分享弹窗": "Close share",
  "关闭文件预览": "Close file preview",
  "关闭群成员": "Close group members",
  "返回规则列表": "Back to rules",
  "关闭禁止加入名单": "Close blocked members",
  "查看群成员": "View group members",
  "关闭功能引导": "Close feature tour",
  "关闭长文": "Close articles",
  "关闭扩展详情": "Close extension details",
  "关闭市集": "Close marketplace",
  "关闭会员窗口": "Close membership dialog",
  "关闭转发对象选择": "Close forwarding destinations",
  "关闭举报": "Close report",
  "关闭快记详情": "Close note details",
  "返回快记详情": "Back to note details",
  "返回相关快记列表": "Back to related notes list",
  "关闭插件更新": "Close extension updates",
  "关闭录音体验": "Close recording tour",
  "关闭预览": "Close preview",
  "关闭截图": "Close screenshot",
  "关闭全局搜索": "Close search everywhere",
  "返回搜索": "Back to search",
  "关闭发给自己引导": "Close saved notes tour",
  "关闭添加联系人": "Close add contact",
  "关闭指定主题": "Close choose topic",
  "关闭主题": "Close topics",
  "关闭登录": "Close sign in",
  "关闭图片预览": "Close image preview",
  "关闭发布窗口": "Close post dialog",
  "关闭上传文件": "Close upload files",
  "关闭已完成": "Close completed",
  "关闭录音引导": "Close recording guide",
  "关闭说话人编辑": "Close speaker editor",
  "关闭当前窗口说话人统计": "Close speaker statistics for this range",
  "关闭转写对比": "Close compare transcripts",
  "返回转发对象": "Back to forwarding destination",
  "关闭录音转发": "Close forward recording",
  "关闭工作区选择": "Close workspace picker",
  "关闭修改备注": "Close edit contact name",
  "关闭相关录音": "Close related recordings",
  "关闭录音详情": "Close recording details"
}
